/* global analytics:true */
/* eslint-disable no-console */

import { forEach as _forEach } from 'lodash';
import async from 'async';
import cookies from 'cookies-js';
import firebase from './firebase.js';
import Hashids from 'hashids';

//import ngcUsers from '../data/ngc-user-lookup.json';

var hashids = new Hashids( process.env.REACT_APP_HASHIDS_SALT );

const fbAuth = firebase.auth();

var postLogin = function( provider, user ) {
    if ( typeof analytics !== 'undefined' ) {
        analytics.identify(user.email, {
            name: user.name,
            email: user.email,
            provider: provider,
            createdAt: user.created_at
        });

        analytics.track('Login Success', {
            label: provider,
            category: 'Activist Dashboard'
        });
    }
};

var loginFailure = function( provider, error ) {
    if ( typeof analytics !== 'undefined' ) {
        analytics.track('Login Failure', {
            label: provider,
            category: 'Activist Dashboard'
        });
    }
};

/** Create our saved profile for a user */
var setProfile = function( provider, user, callback ) {

    let name = user.displayName || ( user.providerData.length > 0 ? user.providerData[0].displayName : false ) || '';

    let userFormatted = {
        name: name,
        provider: provider,
        photo: user.photoURL || '',
        hashid: hashids.encode( new Date().getTime() ),
        email: user.email || ( user.providerData.length > 0 ? user.providerData[0].email : ''),
        created_at: firebase.database.ServerValue.TIMESTAMP,
        updated_at: firebase.database.ServerValue.TIMESTAMP,
        last_loggedin: firebase.database.ServerValue.TIMESTAMP
    };

    /*var ngcUser = _find( ngcUsers, { email: user.email } );

    if ( typeof ngcUser !== 'undefined' ) {
        userFormatted.name = `${ ngcUser.firstname } ${ ngcUser.lastname }`;
        userFormatted.vanID = ngcUser.userid;
        userFormatted.zip = ngcUser.zip;
    }*/

    firebase.database().ref( `users/${ user.uid }` ).set( userFormatted ).then(function( data ) {
        callback( false, data );
    }).catch( ( error ) => {
        callback( error );
    });
};

var updateProfile = function( provider, data, user, callback ) {

    var ref = firebase.database().ref( `users/${ user.uid }` );
    var name = user.displayName || ( user.providerData.length > 0 ? user.providerData[0].displayName : false ) || '';

    ref.update({
        name: name,
        provider: provider,
        photo: user.photoURL || '',
        hashid: data.hashid || hashids.encode( new Date().getTime() ),
        email: user.email || ( user.providerData.length > 0 ? user.providerData[0].email : false ) || data.email || false,
        updated_at: firebase.database.ServerValue.TIMESTAMP,
        last_loggedin: firebase.database.ServerValue.TIMESTAMP
    });

    ref.once('value', function( snapshot ) {
        callback( false, snapshot.val() );
    });

};

/** Return our saved profile for a loggedin user */
var getProfile = function( provider, user, callback ) {

    if ( user && user.uid ) {

        firebase.database().ref( `users/${ user.uid }` ).once('value', function( snapshot ) {

            var data = snapshot.val();

            // Only set or update profile if provider exists
            if ( !user.isAnonymous && provider ) {
                if ( data ) {
                    updateProfile( provider, data, user, callback );
                } else {
                    // Go ahead and save the profile
                    setProfile( provider, user, callback );
                }
            } else if ( !user.isAnonymous && !user.hashid ) {
                // handle case with no hashID
                const provider = user.providerData[0].providerId;
                if ( data ) {
                    updateProfile( provider, data, user, callback );
                } else {
                    setProfile( provider, user, callback );
                }
            } else {
                callback( false, data || {} );
            }

        }).catch(function( error ) {
            callback( error );
        });
    } else {
        callback( true );
    }
};

/** Add a user to a group - Firebase rules enforce validation */
var addGroup = function( userID, group, callback ) {
    var groups = ['organizers', 'admins'];

    if ( groups.indexOf( group ) !== -1 ) {
        // Remove from previous groups
        for ( var i in groups ) {
            firebase.database().ref( `${ groups[i] }/${ userID }` ).remove();
        }

        firebase.database().ref( group ).once('value').then(function( snapshot ) {
            var data = snapshot.val();

            if ( data === null || typeof data[ userID ] === 'undefined' ) {
                // Create group
                firebase.database().ref( `${ group }/${ userID }` ).set({
                    updated_at: firebase.database.ServerValue.TIMESTAMP,
                    created_at: firebase.database.ServerValue.TIMESTAMP
                }).then(function() {
                    callback( false, true );
                });
            } else {
                // All is well, continue
                callback( false, true );
            }
        }).catch( ( error ) => {
            callback( error );
        });
    } else {
        // Invalid group type
        callback( true );
    }
};

/** Return a users groups */
var groups = function( userID, callback ) {
    var groups = ['organizers', 'admins'];
    var memberships = ['users'];
    async.each( groups, ( group, callback ) => {

        firebase.database().ref( group ).orderByKey().equalTo( userID ).once('value', ( snapshot ) => {
            var data = snapshot.val();
            if ( data !== null && snapshot.key === group ) {
                memberships.push( group );
            }
            callback();
        }).catch( ( error ) => {
            callback();
        });
    }, () => {
        callback( false, memberships );
    });
};

/* Get groups for a collection of users */
/* TODO: We should just grab groups for a user at a time on their profile page */
export function getGroupsForUsers( users, callback ) {
    let usersWithGroups = [];

    async.eachSeries( users, ( user, asyncCallback ) => {
        groups( user.id, ( err, groups ) => {
            usersWithGroups.push({...user,
                groups
            });
            asyncCallback();
        });
    }, ( error ) => {
        if ( error ) {
            callback( error );
        } else {
            callback( null, usersWithGroups );
        }
    });
}

/** Return t/f for Firebase loggedIn status */
export function loggedIn( callback ) {
    fbAuth.onAuthStateChanged(( user ) => {
        if ( user ) {
            getProfile( null, user, function( error, nextgenProfile ) {
                if ( typeof callback !== 'undefined' ) {
                    groups( user.uid, function( error, groups ) {
                        callback( false, user, nextgenProfile, groups );
                    });
                }
            });
        } else {
            if ( typeof callback !== 'undefined' ) {
                callback( true );
            }
        }
    });
}

/** Log a user in anonmously, which is like a session */
export function session( callback ) {
    loggedIn(function( error, user, nextgenProfile, groups ) {
        if ( !user ) {
            fbAuth.signInAnonymously().then(function( result ) {
                if ( result ) {
                    callback( false, result );
                } else {
                    callback( true );
                }
            });
        } else {
            callback( false, user, nextgenProfile, groups );
        }
    });
}

/** Synchronously return the user. NOTE: does not work before firebase is inited. */
export function user() {
    return fbAuth.currentUser;
}

/** Login with an (existing) username and password */
export function loginPassword( email, password, callback ) {
    fbAuth.signInWithEmailAndPassword( email, password ).then(function( result ) {
        getProfile( 'password', result, function( error, nextgenProfile ) {

            groups( result.uid, function( error, groups ) {
                postLogin( 'password', nextgenProfile );

                callback( false, result, nextgenProfile, groups );
            });
        });
    }).catch(function( error ) {
        loginFailure( 'password', error.message );

        callback( error );
    });
}

/** Register a user to use username and password logins. Firebase handles forgotten passwords, verification */
export function registerPassword( email, password, callback ) {

    var afterLogin = ( result ) => {
        getProfile( 'password', result, function( error, nextgenProfile ) {
            groups( result.uid, function( error, groups ) {
                postLogin( 'password', result );

                callback( false, result.user, nextgenProfile, groups );
            });
        });
    };

    var caughtError = ( error ) => {
        if ( error.code === 'auth/email-already-in-use' ) {
            loginPassword( email, password, callback );
        } else {
            loginFailure( 'password', error.message );

            callback( error );
        }
    };

    var ranLoggedIn = false;

    session( ( error, user ) => {
        if ( !ranLoggedIn ) { // Promises don't stop multiple calls
            ranLoggedIn = true;
            var anonUser, credential;

            if ( user && user.isAnonymous ) {
                anonUser = user;
                credential = firebase.auth.EmailAuthProvider.credential(email, password);

                anonUser.link( credential ).then( afterLogin ).catch( caughtError );
            } else {
                firebase
                    .auth().createUserWithEmailAndPassword( email, password )
                    .then(afterLogin).catch(caughtError);
            }
        }
    });
}

/** Login a user via Facebook */
export function loginFacebook( callback ) {
    var provider = new firebase.auth.FacebookAuthProvider();
    provider.addScope('email');
    provider.addScope('user_location');

    var afterLogin = ( result ) => {
        getProfile( 'facebook', result.user, function( error, nextgenProfile ) {
            groups( result.user.uid, function( error, groups ) {
                postLogin( 'facebook', nextgenProfile );

                callback( false, result.user, nextgenProfile, groups );
            });
        });
    };

    var caughtError = ( error ) => {
        loginFailure( 'facebook', error.message );

        callback( error );
    };

    // get account
    // if anon, linkWithPopup
    var ranLoggedIn = false;

    loggedIn( ( error, user ) => {
        if ( !ranLoggedIn ) { // Promises don't stop multiple calls
            if ( user && user.isAnonymous ) {
                user.linkWithPopup( provider ).then(afterLogin).catch(( error ) => {
                    // This error will likely occur if the user already exists. We need to log them in.
                    if ( error.code === 'auth/credential-already-in-use' ) {
                        fbAuth.signInWithPopup( provider ).then(afterLogin).catch(caughtError);
                    } else {
                        callback( error );
                    }
                });
            } else {
                fbAuth.signInWithPopup( provider ).then(afterLogin).catch(caughtError);
            }

            ranLoggedIn = true;
        }
    });
}

/** Login a user via Google (Team Nextgen only) */
function loginGoogle( callback ) {
    var provider = new firebase.auth.GoogleAuthProvider();
    provider.addScope('email');
    provider.addScope('profile');

    fbAuth.signInWithPopup( provider ).then(function( result ) {
        // Note: the variable is different on prod and dev.
        var email = result.user.email || result.user.providerData[0].email;

        if ( email.indexOf('@nextgenclimate.org') === -1 &&
            email.indexOf('@nextgenamerica.org') === -1 &&
            email.indexOf('@patronage.org') === -1 ) {

            fbAuth.signOut();

            throw new Error('Sorry, you cannot use Google Login with this account');
        } else {
            // Set cookie to show admin login primarily next time
            cookies.set('NEXTGEN-ACTIVIST-ADMIN', 'true');

            // Get (and Set) user profile
            getProfile( 'google', result.user, function( error, nextgenProfile ) {
                groups( result.user.uid, function( error, inGroups ) {
                    if ( inGroups.indexOf('organizers') === -1 && inGroups.indexOf('admins') === -1 ) {
                        // Add user to Nextgen Admins
                        addGroup( result.user.uid, 'organizers', function( error, succeeded ) {
                            // Re-fetch the groups because we changed them
                            groups( result.user.uid, function( error, inGroups ) {
                                postLogin( 'google', nextgenProfile );

                                callback( false, result.user, nextgenProfile, inGroups );
                            });
                        });
                    } else {
                        postLogin( 'google', nextgenProfile );

                        callback( false, result.user, nextgenProfile, inGroups );
                    }
                });
            });
        }
    }, function( error ) {
        loginFailure( 'google', error.message );

        callback( error );
    }).catch(function( error ) {
        loginFailure( 'google', error.message );

        callback( error );
    });
}

/** Logout a user */
export function logout( callback ) {
    fbAuth.signOut().then(function() {
        callback( false, true );
    }, function( error ) {
        callback( error );
    });
}

/* Set basic fields for anon user so they can be saved to EveryAction */
export function setNextgenProfile( user, fields, callback ) {
    var ref = firebase.database().ref( `users/${ user.uid }` );

    // TODO:
    // rename setNextgenProfile
    // document how differrent from setProfile (rename setLoginprofile)
    // if set, only apply saved fields

    // Map field names consistantly
    // (We get fields from Everyaction forms and our own)
    var mappedFields = {};

    _forEach(fields, ( field, i ) => {
        switch( i ) {
            case 'zip':
            case 'PostalCode':
                mappedFields.zip = field;
                break;

            case 'email':
            case 'EmailAddress':
                mappedFields.email = field;
                break;

            case 'firstname':
            case 'FirstName':
                mappedFields.firstname = field;
                break;

            case 'lastname':
            case 'LastName':
                mappedFields.lastname = field;
                break;

            case 'phone':
            case 'MobilePhone':
                mappedFields.phone = field;
                break;

            case 'partner':
            case 'Partner':
                mappedFields.partner = field;
                break;

            default:
                // n/a
                break;
        }
    });

    ref.once('value', function( snapshot ) {
        var data = snapshot.val();

        if ( data ) {
            mappedFields.updated_at = firebase.database.ServerValue.TIMESTAMP;
            ref.update( mappedFields );
        } else {
            mappedFields.provider = 'anonymous';
            mappedFields.created_at = firebase.database.ServerValue.TIMESTAMP;
            mappedFields.updated_at = firebase.database.ServerValue.TIMESTAMP;
            mappedFields.name = mappedFields.firstname + ' ' + mappedFields.lastname;
            ref.set( mappedFields );
        }

        ref.once('value', function( snapshot ) {
            callback( false, snapshot.val() );
        });
    });
}

/* Get basic fields for anon user so they can be saved to EveryAction */
export function getNextgenProfile( user, callback ) {
    firebase.database().ref( `users/${ user.uid }` ).once('value', function( snapshot ) {
        var data = snapshot.val();

        if ( data ) {
            callback( false, data );
        } else {
            callback( true );
        }
    }).catch(function( error ) {
        callback( error );
    });
}

export function resetPassword( userEmail, callback ) {
    const resetSuccess = () => {
        callback();
    };

    const resetFail = ( err ) => {
        callback( err );
    };

    fbAuth
        .sendPasswordResetEmail( userEmail )
        .then( resetSuccess, resetFail );

}

export function confirmPasswordReset( resetCode, newPassword, callback ) {
    const confirmSuccess = () => {
        callback( null );
    };

    const confirmFail = ( err ) => {
        callback( err );
    };

    fbAuth
        .confirmPasswordReset( resetCode, newPassword )
        .then( confirmSuccess, confirmFail );
}

export default {
    loggedIn, session, user, loginPassword, registerPassword, loginFacebook,
    loginGoogle, logout, setNextgenProfile, getNextgenProfile, resetPassword,
    confirmPasswordReset, addToGroup: addGroup, getGroupsForUser: groups
};



// WEBPACK FOOTER //
// ./src/library/auth.js